import React from 'react';
import classes from './../Auth.module.scss';
import { BoxNotification } from '../../../components/containers/BoxNotification';
import { MappedOrganization } from './SwitchOrganization.controller';
import { Button } from '../../../components/actions/Button';
import { ButtonColorsEnum } from '../../../constants/button-colors';
import { IconsEnum } from '../../../constants/icons';

export type SwitchOrganizationViewProps = {
  loading: boolean;
  organizations?: MappedOrganization[];
  switchOrganizationAction: (id: string) => void;
  userError: JSX.Element | string;
};

export const SwitchOrganizationView = (props: SwitchOrganizationViewProps): JSX.Element => {
  return props.loading ? (
    <p>Loading...</p>
  ) : (
    <div className={classes.Title}>
      <div className={'margin-bottom-small-40'}>
        <h2>Choose an Organization</h2>
      </div>
      <div className={'margin-bottom-small-32'}>
        <BoxNotification type={'info'}>
          <p>Which organization do you want to open? You can switch at any time.</p>
        </BoxNotification>
      </div>
      {props.userError && (
        <div className={'margin-bottom-small-32'}>
          <BoxNotification type={'error'}>{props.userError}</BoxNotification>
        </div>
      )}
      {props.organizations &&
        props.organizations.map((organization, index) => (
          <div
            className={
              (props.organizations as MappedOrganization[]).length > index + 1 ? 'margin-bottom-small-24' : undefined
            }
            key={index}>
            <Button
              action={() => props.switchOrganizationAction(organization.workspaceId)}
              type={'button'}
              variant={'solid'}
              size={'large'}
              color={ButtonColorsEnum.secondary}
              expanded
              justifiedIcon
              icon={{ side: 'right', value: IconsEnum.arrowRight }}>
              {organization.name}
            </Button>
          </div>
        ))}
    </div>
  );
};
